import "UI/Widget/Form";
import "UI/Widget/Forms/Render/Light";
import 'Cadastre/Data/Cadnums'
import eventsCondition from 'ol/events/condition'


/** @namespace Accounting.UI */
NS('Cadastre.UI');

/**
 * @class
 * @extends UI.Widget.Form
 * @extends UI.Widget.Forms.Render.Light
 */
Cadastre.UI.MapForm = Class(
	UI.Widget.Form,
	UI.Widget.Forms.Render.Light, {

		mapCenter: null,
		mapZoom: null,

		item: null,
		currentFeature: null,

		map: null,
		layer: null,

		titleField: null,
		title: 'Выбор участка',

		formButtons: [{
			name: 'save',
			title: "Выбрать",
			onClick: 'onSelectClick',
			hidden: false,
			float: "left",
			//access: () => this.canSave()
		}, {
			name: 'cancel',
			title: "Отмена",
			onClick: 'onCancelClick',
			hidden: false,
			float: "left",
			//access: () => this.canSave()
		}],

		/** @inheritDoc */
		render() {
			this.ParentCall();
			this.renderMap();
			this.renderContainer();

			return this;
		},
		async renderMap () {
			this.$body.find('.page').css('height', '380px');
			this.map = new GIS.UI.Map(this, {
				'class': GIS.Map.OL3,
				//layersSourceClass: Util.coalesce(this.$control.attr('layer-source'), 'GIS.Data.Layers'),
				//featuresSourceClass: Util.coalesce(this.$control.attr('feature-source'), 'GIS.Data.LayerFeatures'),
				center: [5632194.111120067, 7428300.1228000745],
				zoom: Util.coalesce(this.mapZoom, 6),
				initControls: {
					//fullscreen: false
				},
				interactionOptions: {
					select: {
						condition: evt => eventsCondition.doubleClick(evt),
						toggleCondition: evt => !!this.map.getMap().forEachFeatureAtPixel(evt.pixel, feature => feature === this.currentFeature)
					}
				}
			}).render().appendTo(this.$body.find('.page'));

			this.map.once("ready", async function () {
				if (this.item && this.item.geog)
					this.map.getMap().fit(this.item.geog);

				this.layer = await this.map.showLayer({id: 0,
					jsclass: "GIS.Map.Layer.GlonassVector",
					servicecode: 'cadastre',
					name: "Кадастровые участки",
					layername: "cadastre",
					projection: {
						code: "4326",
						codename: "EPSG",
						extent: [-180, -90, 180, 90],
						fullcode: "EPSG:4326"
					}
				}, true , {
					minZoom: 13,
					ds: Util.create('Cadastre.Data.Cadnums'),
					opacity: 0.7,
					dsMethod: "find"
				});
				this.layer.on('load', this.onFeatureLoad.bind(this))
					.on("feature.select", this.onFeatureSelect, this);
			}, this);

		},
		onFeatureLoad (e) {
			if (this.item && !this.currentFeature) {
				this.currentFeature = this.layer.getFeature(this.item.id);
				if (this.currentFeature)
					this.layer.selectFeature(this.currentFeature);
			}
		},
		onFeatureSelect (e) {
			this.currentFeature = e.feature;
		},
		onSelectClick () {
			this.emit("select", _.pick(this.currentFeature.values_, ['id', 'cadnum']));
			this.close();
		}
	}
);
